import { CSSProperties } from "react";
import { ResourceType } from "~/business";
import { expectNever } from "~/utils";
import { XCardIconSvg, XDreadnought, XTechNegociator } from "./svg";
import { XCombatPointSvg } from "./svg";
import { XInfluentPointSvg } from "./svg";
import { XIntrigueCardSvg } from "./svg";
import { XResourceType } from "./svg";
import { XSolarisSvg } from "./svg";
import { XSpiceSvg } from "./svg";
import { XVictoryPointSvg } from "./svg";
import { XWaterSvg } from "./svg";
import { XTroop } from "./XTroop";

export const XResource = ({
  type,
  width,
  style,
}: {
  type: XResourceType;
  width: number;
  style?: CSSProperties;
}) => {
  switch (type) {
    case ResourceType.Solaris:
      return <XSolarisSvg width={width} style={style} />;
    case ResourceType.Spice:
      return <XSpiceSvg width={width} style={style} />;
    case ResourceType.Water:
      return <XWaterSvg width={width} style={style} />;
    case "influence":
      return <XInfluentPointSvg width={width} style={style} />;
    case "victory":
      return <XVictoryPointSvg width={width} style={style} />;
    case "troop":
      return <XTroop width={width} style={style} />;
    case "card":
      return <XCardIconSvg width={width} style={style} />;
    case "intrigueCard":
      return <XIntrigueCardSvg width={width} style={style} />;
    case "combatPoint":
      return <XCombatPointSvg width={width} style={style} />;
    case "techNegociator":
      return <XTechNegociator width={width} style={style} />;
    case "dreadnought":
      return <XDreadnought width={width} style={style} />;
    default:
      expectNever(type);
      throw new Error();
  }
};
